import { jsx as _jsx } from "react/jsx-runtime";
export const CmdArea = (props) => {
    const style = {
        backgroundColor: '#ccbccc',
        padding: '4px 10px',
        border: '1px solid black',
        borderRadius: '0px'
    };
    return (_jsx("div", { style: style, children: props.children }));
};
